const ClockIcon = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_69)">
        <path
          d="M15.5 0C19.4782 0 23.2936 1.58035 26.1066 4.3934C28.9196 7.20644 30.5 11.0218 30.5 15C30.5 18.9782 28.9196 22.7936 26.1066 25.6066C23.2936 28.4196 19.4782 30 15.5 30C11.5218 30 7.70644 28.4196 4.8934 25.6066C2.08035 22.7936 0.5 18.9782 0.5 15C0.5 11.0218 2.08035 7.20644 4.8934 4.3934C7.70644 1.58035 11.5218 0 15.5 0ZM14.0938 7.03125V15C14.0938 15.4688 14.3281 15.9082 14.7207 16.1719L20.3457 19.9219C20.9902 20.3555 21.8633 20.1797 22.2969 19.5293C22.7305 18.8789 22.5547 18.0117 21.9043 17.5781L16.9062 14.25V7.03125C16.9062 6.25195 16.2793 5.625 15.5 5.625C14.7207 5.625 14.0938 6.25195 14.0938 7.03125Z"
          fill="#0051FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_69">
          <path d="M0.5 0H30.5V30H0.5V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
